export default "/etc.clientlibs/des/ploom/clientlibs/publish/des-react-hybrid/resources/0601dcf4ff299fe16a0af1e945ea518a.png";